"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInputVariant = void 0;
var _react = require("react");
const useInputVariant = (focused, variant) => {
  return (0, _react.useMemo)(() => focused && variant !== 'positive' && variant !== 'negative' ? 'primary' : variant, [focused, variant]);
};
exports.useInputVariant = useInputVariant;